import React from 'react';
import { getMobileAlarmListByMC } from '../../../../api/dashboard';
import helper from '../../../../utils/helper';
import {
  getSharedDefaultStyles,
  getSpacingAround,
} from '../../Configure/DashboardCustom/functions';

const MonitoringPointWidget = (props) => {
  const refreshRate = helper.getSetting('ValueRefreshRateSec').value * 1000;
  const intervalRef = React.useRef();
  const [alarmList, updateAlarmList] = React.useState([]);
  function getData() {
    getMobileAlarmListByMC()
      .then((resp) => updateAlarmList(resp))
      .catch((err) => console.log('alarm list err', err));
  }

  const getIntervalData = () => {
    const interval = setInterval(() => {
      getData();
    }, refreshRate);
    return interval;
  };

  React.useEffect(() => {
    getData();
    intervalRef.current = getIntervalData();
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);
  function getBgColor(alarmPriority) {
    let color = '';
    switch (alarmPriority) {
      //green
      case 0:
        color = '#75e5d0';
        break;
      case 1:
        //yellow
        color = '#fcf496';
        break;
      case 2:
        //red
        color = '#ffb0be';
        break;
      default:
        //blue
        color = '#6bcfed';
        break;
    }
    return color;
  }
  function getFlexByColumn() {
    const flexPercentage =
      100 / parseInt(props.extraProperties.numberOfColumns || 1);
    return `0 0 ${flexPercentage}%`;
  }
  function getStyles() {
    let val = parseInt(props.width);
    return {
      width: val < 0 ? '100%' : val,
      ...getSharedDefaultStyles(),
      ...getSpacingAround(
        props.extraProperties.spacingTop,
        props.extraProperties.spacingRight,
        props.extraProperties.spacingBottom,
        props.extraProperties.spacingLeft,
      ),
    };
  }

  return (
    <div style={getStyles()}>
      <div className="d-flex justify-content-between align-items-end mb-10">
        <div>
          {props.title ? <h1>{props.title}</h1> : null}
          {props.description ? (
            <span style={{ fontStyle: 'italic' }}>{props.description}</span>
          ) : null}
        </div>
        <div className="d-flex flex-1 justify-content-end align-items-end">
          {/* <ActionsDropdown options={actions} /> */}
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${parseInt(
            props.extraProperties.numberOfColumns || 1,
          )}, 1fr)`,
          columnGap: parseInt(props.extraProperties.columnGap || 0),
          rowGap: parseInt(props.extraProperties.rowGap || 0),
        }}
      >
        {alarmList
          // .filter((alarm) => {
          //   if (search === null) {
          //     return alarm;
          //   } else {
          //     return search.includes(alarm.sensorId);
          //   }
          // })
          .filter(
            (alarm) =>
              props.extraProperties.alarms &&
              JSON.parse(props.extraProperties.alarms)
                .map((al) => al.sensorId)
                .includes(alarm.sensorId),
          )
          .filter((alarm) => {
            if (props.isAlert) {
              return alarm.alarmPriority !== 0;
            } else return alarm;
          })
          .map((al) => {
            return (
              <div
                key={al.sensorId}
                className="d-flex"
                style={{
                  backgroundColor: getBgColor(al.alarmPriority),
                  flex: getFlexByColumn(),
                }}
              >
                <div
                  className="d-flex flex-column w-100"
                  style={{
                    padding: 10,
                    //  border: '0.3px solid gray'
                  }}
                >
                  <div className="d-flex">
                    <div className="flex-1">
                      <span style={{ fontSize: 14, fontWeight: '500' }}>
                        {al.name}
                      </span>
                      <br />
                      <span style={{ fontSize: 12 }}>{al.location}</span>
                      <br />
                      <span style={{ fontSize: 12 }}>{al.groupName}</span>
                      <br />
                      {al.alarmPriority === 2 && (
                        <>
                          <span style={{ fontSize: 10 }}>
                            {al.timeDetected}
                          </span>
                          <br />
                        </>
                      )}
                      {al.alarmPriority !== 0 && (
                        <span style={{ fontSize: 10 }}>{al.alarmType}</span>
                      )}
                    </div>
                    {/* <div>
                    <CustomInput type="checkbox" checked />
                  </div> */}
                  </div>
                  <div style={{ textAlign: 'end' }}>
                    <span
                      style={{ fontSize: 16, fontWeight: '500', lineHeight: 1 }}
                    >
                      {al.units}
                    </span>
                    <br />
                    <span
                      style={{
                        fontSize: 22,
                        fontWeight: 'bold',
                        lineHeight: 2,
                      }}
                    >
                      {al.textValue}
                    </span>
                    <br />
                    <span className="m-dashboard-time-info">{al.timeInfo}</span>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MonitoringPointWidget;
